import { useState } from 'react'

import BrowserSupportModal from '../../modals/BrowserSupportModal'

export const Footer = () => {
  const [showBrowserModal, setShowBrowserModal] = useState(false)
  return (
    <footer
      style={{
        background: 'var(--dark-brown)',
        color: 'var(--white)',
        padding: '80px 32px 32px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
        }}
      >
        {/* Footer Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '48px',
            marginBottom: '48px',
          }}
        >
          {/* Brand Column */}
          <div>
            <h3
              style={{
                fontFamily: 'var(--font-heading)',
                fontSize: '1.5rem',
                fontWeight: '700',
                margin: '0 0 16px 0',
                color: 'var(--white)',
              }}
            >
              Free Pattern Warehouse
            </h3>
            <p
              style={{
                margin: '0 0 16px 0',
                fontSize: '0.875rem',
                color: 'var(--light-gray)',
                lineHeight: '1.6',
              }}
            >
              The world's warehouse for creative patterns and crafting inspiration.
            </p>
            {/* Social Icons Placeholder */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  background: 'var(--light-gray)',
                  borderRadius: '4px',
                }}
              />
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  background: 'var(--light-gray)',
                  borderRadius: '4px',
                }}
              />
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  background: 'var(--light-gray)',
                  borderRadius: '4px',
                }}
              />
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  background: 'var(--light-gray)',
                  borderRadius: '4px',
                }}
              />
            </div>
          </div>

          {/* Explore Column */}
          <div>
            <h4
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '1rem',
                fontWeight: '700',
                margin: '0 0 16px 0',
                color: 'var(--white)',
              }}
            >
              Explore
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>
                  New Patterns
                </span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>
                  Popular Crafts
                </span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>
                  Featured Creators
                </span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>Supply Shop</span>
              </li>
            </ul>
          </div>

          {/* Community Column */}
          <div>
            <h4
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '1rem',
                fontWeight: '700',
                margin: '0 0 16px 0',
                color: 'var(--white)',
              }}
            >
              Community
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>Forums</span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>Blog</span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>Events</span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <span style={{ color: 'var(--light-gray)', fontSize: '0.875rem', cursor: 'default' }}>Help Center</span>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <a href="/supporting-artists" style={{ color: 'var(--light-gray)', fontSize: '0.875rem', textDecoration: 'none' }}>
                  Supporting Artists
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: '1rem',
                fontWeight: '700',
                margin: '0 0 16px 0',
                color: 'var(--white)',
              }}
            >
              Join Our Newsletter
            </h4>
            <p
              style={{
                margin: '0 0 16px 0',
                fontSize: '0.875rem',
                color: 'var(--light-gray)',
                lineHeight: '1.6',
              }}
            >
              Get weekly inspiration and free patterns delivered to your inbox.
            </p>
            <div style={{ display: 'flex', gap: '0' }}>
              <input
                type="email"
                placeholder="Your email"
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  border: 'none',
                  borderRadius: '0',
                  background: 'var(--medium-brown)',
                  color: 'var(--white)',
                  fontSize: '1rem',
                  fontFamily: 'var(--font-body)',
                }}
              />
              <button
                style={{
                  padding: '10px 16px',
                  border: 'none',
                  background: 'var(--primary-teal)',
                  color: 'var(--white)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: '1px solid var(--medium-brown)',
            paddingTop: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          <p style={{ margin: '0', fontSize: '0.875rem', color: 'var(--light-gray)' }}>
            © 2025 Free Pattern Warehouse. All Rights Reserved.
          </p>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <a
              href="/roadmap"
              style={{
                color: 'var(--light-gray)',
                textDecoration: 'none',
                fontSize: '0.875rem',
              }}
            >
              Roadmap
            </a>
            <a
              href="/supporting-artists"
              style={{
                color: 'var(--light-gray)',
                textDecoration: 'none',
                fontSize: '0.875rem',
              }}
            >
              Supporting Artists
            </a>
            <button
              onClick={() => setShowBrowserModal(true)}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--light-gray)',
                textDecoration: 'none',
                cursor: 'pointer',
                fontSize: '0.875rem',
                padding: 0,
              }}
            >
              Supported Browsers
            </button>
          </div>
        </div>

        <BrowserSupportModal visible={showBrowserModal} onDismiss={() => setShowBrowserModal(false)} />
      </div>
    </footer>
  )
}

export default Footer
